import * as React from 'react';

export default function useExternalScript({ id, src }: { id: string; src: string }): boolean {
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    const existingScript = document.getElementById('easyxdm-script');
    if (existingScript) {
      if (existingScript.loaded) {
        setLoaded(true);
      } else {
        existingScript.addEventListener('load', () => {
          existingScript.loaded = true;
          setLoaded(true);
        });
      }
    } else {
      const script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.addEventListener('load', () => {
        script.loaded = true;
        setLoaded(true);
      });
      document.head.appendChild(script);
    }
  }, []);

  return loaded;
}
